import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import createHistory from 'history/createBrowserHistory'
import { History } from 'history'
import * as firebase from 'firebase/app'
import 'firebase/database'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import classNames from 'classnames'
import * as AnalyticsManager from './lib/analytics/analytics'
import I18nWrapper from './containers/I18nWrapper'
import { currentLocale, isRtl } from './config/locales'
import gettEnv from './config/gettEnv'
import './vendors'
import styles from './App.module.scss'
import configureStore from './configureStore'
import { Routes } from './Routes'
import AppHeader from './containers/AppHeader/AppHeader'
import AppFooter from './containers/AppFooter/AppFooter'

AnalyticsManager.init()

const firebaseConfig = {
  apiKey: gettEnv.REACT_APP_FIREBASE_API_KEY,
  authDomain: gettEnv.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: gettEnv.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: gettEnv.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: gettEnv.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: gettEnv.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
}

firebase.initializeApp(firebaseConfig)

const history = createHistory()
const initialState = window.initialReduxState
const store = configureStore(history, initialState)

const rrfConfig = {
  enableLogging: false,
  dispatch: store.dispatch,
}

interface AppProps {
  history: History
}

const Root = ({ history }: AppProps) => {
  const appClasses = {
    [styles.app]: true,
    [styles.rtl]: isRtl(),
  }

  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider
        firebase={firebase}
        config={rrfConfig}
        dispatch={store.dispatch}>
        <I18nWrapper locale={currentLocale()}>
          <ConnectedRouter history={history}>
            <div className={classNames(appClasses)}>
              <AppHeader />
              <div className={styles.appBody}>
                <Routes />
              </div>
              <AppFooter />
            </div>
          </ConnectedRouter>
        </I18nWrapper>
      </ReactReduxFirebaseProvider>
    </Provider>
  )
}

class App extends Component {
  render() {
    return (
      <Root history={history} />
    )
  }
}

export default App
